(function () {
  angular.module('MktzapApp.Controllers')
    .controller('RiskListController', RiskListController);

  RiskListController.$inject = ['$http', 'NotificationService', 'RiskListService', 'FoundationApi', 'Upload', 'ngTableParams', 'LangService'];

  function RiskListController($http, NotificationService, RiskListService, FoundationApi, Upload, ngTableParams, LangService) {
    var vm = this;
    vm.labelsPage = ''
    vm.phoneMask = "(99) 9?9999-9999";
    vm.documentMask = "999.999.999-99";
    vm.dataMask = "99/99/9999";
    vm.newDocument = "";
    vm.document = "";
    vm.status_filter = "";
    vm.first_period_filter = moment().startOf("month").format("DD/MM/YYYY");
    vm.end_period_filter = moment().endOf("month").format("DD/MM/YYYY");
    filterBlockedPersons()

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };


    LangService
      .getPageLabels({ 'page': 'menu.riskList' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    function filterBlockedPersons() {
      vm.blockedPersonTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          let filters = {
            page: params.url().page,
            phone: vm.phone,
            document: vm.document,
            status: vm.status_filter,
            first_period: vm.first_period_filter,
            end_period: vm.end_period_filter
          }
          RiskListService
            .getBlocked(filters)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.data);
                params.total(data.total);
                vm.totalBlockedPersons = data.total;
                vm.tableBlockedPersons = data.data;
              } else {
                NotificationService.errorHandler(data, vm.labelsPage.noDataFound);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, vm.labelsPage.failGetData);
            });
        }
      })
    }

    vm.cleanFilters = () => {
      vm.phone = null
      filterBlockedPersons()
    }

    vm.filterBlockedPersons = () => {
      filterBlockedPersons()
    }

    vm.removeBlockPerson = (blockedPerson) => {
      vm.blockedPerson = blockedPerson
      FoundationApi.publish('removeBlockModal', 'open')
    }

    vm.removeBlock = (external_id) => {
      RiskListService
        .removeBlock(external_id)
        .$promise
        .then(function (data) {
          filterBlockedPersons()
          FoundationApi.publish('removeBlockModal', 'close')
          NotificationService.successHandler(data, vm.labelsPage.contactReleaseSuccess);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.contactReleaseFail);
        })
    }

    vm.addBlockedPerson = () => {
      FoundationApi.publish('registerBlockedPerson', 'open')
    }

    vm.addNewBlockedPerson = () => {
      if (!vm.newName || vm.newName.trim() === '') {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.requiredNameField ? vm.labelsPage.requiredNameField : 'Favor preencher o campo nome!'
        );
      }
      if (!vm.newPhone || vm.newPhone.trim() === '') {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.requiredPhoneField ? vm.labelsPage.requiredPhoneField : 'Favor preencher o campo telefone!'
        );
      }
      if (vm.newDocument != "" && vm.newDocument.length != 11) {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.invalidDocument ? vm.labelsPage.invalidDocument : 'CPF inválido!'
        );
      }
      RiskListService
        .save({
          name: vm.newName, 
          phone: vm.newPhone, 
          document: vm.newDocument
        }).$promise
        .then(function (data) {
          vm.newName = ''
          vm.newPhone = ''
          vm.newDocument = ''
          filterBlockedPersons()
          FoundationApi.publish('registerBlockedPerson', 'close')
          NotificationService.successHandler(data, vm.labelsPage.contactBlockSuccess);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.contactBlockFail);
        })
    }


    //IMPORT FUNCTIONS


    vm.import = () => {
      FoundationApi.publish('importModal', 'open')
    }

    window.upload_file = upload_file;

    vm.file_explorer = file_explorer;


    var fileobj;

    function upload_file(e) {
      e.preventDefault();
      fileobj = e.dataTransfer.files[0];
      validateFileUpload(fileobj);
    }


    function file_explorer() {
      document.getElementById('selectfile').click();
      document.getElementById('selectfile').onchange = function () {
        fileobj = document.getElementById('selectfile').files[0];
        validateFileUpload(fileobj);
      };
    }

    function validateFileUpload(file_obj) {
      vm.uploadedFile = null;
      if (file_obj != undefined) {
        if (file_obj.type !== 'text/csv' && file_obj.type !== 'application/vnd.ms-excel') {
          NotificationService.errorHandler(file_obj, vm.labelsPage.noCsvFile)
        } else {
          vm.uploadedFile = file_obj;
          NotificationService.successHandler(file_obj, vm.labelsPage.successImportFile)
        }
      } else {
        NotificationService.errorHandler(file_obj, vm.labelsPage.failImportFile)
      }
    }

    vm.saveUploadedFile = () => {
      Upload.upload({
        url: frontUrl + '/risk-list/import',
        file: vm.uploadedFile
      })
        .then(function (response) {
          filterBlockedPersons()
          NotificationService.successHandler(response, vm.labelsPage.sucessImportData)
          vm.uploadedFile = null
          FoundationApi.publish('importModal', 'close')
        })
        .catch(function (response) {
          NotificationService.errorHandler(response, vm.labelsPage.failImportData)
        })
    }

    vm.download = () => {
      $http({
        url: frontUrl + '/risk-list/getBlocked',
        method: 'GET',
        responseType: 'blob',
        params: {
          phone: vm.phone,
          document: vm.document,
          status: vm.status_filter,
          first_period: vm.first_period_filter,
          end_period: vm.end_period_filter,
          download: true
        }
      }).then(
        (data) => {
          blob = new Blob([data.data], { type: "text/csv" });
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";

          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "risk_list.csv";
          a.click();
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          NotificationService.errorHandler(data, vm.labelsPage.failGetData);
        } 
      );
    }

  }
})();
